import React, { FC } from "react";

import { startOfMonth, endOfMonth } from "date-fns";

import {
  useApisPartnerConsolesCompaniesAnalyticsMeetingNotesIndex,
  useDateRange,
  usePartnerConsolesMultiDivisionMultiSectionDropdown,
  usePrevNextSelectMonth,
  usePartnerConsolesCompaniesDropdown,
} from "~/hooks";

import { PartnerConsoleLayout } from "~/components/layouts";
import { AnalyticsMeetingNotesTemplate } from "~/components/templates";

import { LabelWithDropDownField } from "~/ui";

const today = new Date();

export const PartnerConsolesAnalyticsMeetingNotesIndex: FC = () => {
  const query = new URLSearchParams(location.search);
  const companyId = query.get("company_id") || "";
  const breadCrumbItems = [
    {
      label: "パートナー画面",
      href: "/partner_consoles",
    },
    {
      label: "1on1・MTG分析",
      href: "/partner_consoles/analytics/meeting_notes",
    },
  ];

  const [{ onChangeCompany, dropdownSelectableValue, dropdownValue, company }] =
    usePartnerConsolesCompaniesDropdown({
      defaultCompanyId: companyId,
    });

  const {
    selectableDivisions,
    selectedDivisions,
    onDivisionChange,
    optionSelectableSections,
    optionSelectedSections,
    onSectionChange,
    selectableEmployees,
    selectedEmployee,
    onEmployeeChange,
  } = usePartnerConsolesMultiDivisionMultiSectionDropdown({
    companyId: company?.id || "",
    isSelectEmployee: true,
  });

  const [
    {
      startDate,
      formattedStartDate,
      endDate,
      dateArray,
      formattedEndDate,
      onChange: onChangeDateRange,
    },
  ] = useDateRange([startOfMonth(today), endOfMonth(today)]);

  const {
    targetDate,
    targetDateString,
    handlePrevMonthClick,
    handleNextMonthClick,
  } = usePrevNextSelectMonth();

  const { data, isLoading } =
    useApisPartnerConsolesCompaniesAnalyticsMeetingNotesIndex({
      companyId: company?.id || "",
      params: {
        businessDivisionIds: selectedDivisions.map((division) => division.id),
        businessSectionIds: optionSelectedSections.map((section) => section.id),
        fromDate: formattedStartDate || undefined,
        toDate: formattedEndDate || undefined,
        targetDate: targetDateString,
        employeeIds: selectedEmployee ? [selectedEmployee.id] : undefined,
      },
      config: {
        enabled: !!(formattedStartDate && formattedEndDate && company),
      },
    });

  return (
    <>
      <PartnerConsoleLayout
        breadCrumbItems={breadCrumbItems}
        companyId={company?.id}
      >
        <LabelWithDropDownField
          required
          labelText="会社"
          name="company"
          options={dropdownSelectableValue}
          value={dropdownValue}
          onChange={onChangeCompany}
        />
        <AnalyticsMeetingNotesTemplate
          formattedStartDate={formattedStartDate}
          formattedEndDate={formattedEndDate}
          selectedDivisions={selectedDivisions}
          optionSelectedSections={optionSelectedSections}
          data={data}
          className="mt-8"
          isLoading={isLoading}
          onChangeDateRange={onChangeDateRange}
          onDivisionChange={onDivisionChange}
          onSectionChange={onSectionChange}
          selectableDivisions={selectableDivisions}
          optionSelectableSections={optionSelectableSections}
          startDate={startDate}
          endDate={endDate}
          selectedDropdownSections={optionSelectedSections}
          dateArray={dateArray}
          selectedEmployee={selectedEmployee}
          onEmployeeChange={onEmployeeChange}
          selectableEmployees={selectableEmployees}
          targetDate={targetDate}
          handlePrevMonthClick={handlePrevMonthClick}
          handleNextMonthClick={handleNextMonthClick}
        />
      </PartnerConsoleLayout>
    </>
  );
};
